import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';

const state = {
    paises: [],
    /* Opciones de filtro y paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    paisesSelect: [],
    listSelect: []
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.paises = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;
    },
    
    'INICIALIZAR_PAISES'(state) {
        state.paises = [];
    },
    'PAISES'(state, paises) {
        state.paises = paises;
    },
    'PAISES_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_SELECT'(state) {
        state.paisesSelect = [];
        state.listSelect = [];
    },
    'PAISES_SELECT'(state, paisesSelect) {
        state.paisesSelect = paisesSelect;
    },
    'LIST_SELECT'(state, listSelect) {
        state.listSelect = listSelect;
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getPaises: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PAISES');

            var queryString = ''
            if ( state.paginaActual != 0) {
              queryString = '?'
                + 'pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
            }
      
            apiAxios.get('paises' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('PAISES_PAGINATION', params);
                    }
                    commit('PAISES', res.data)
                    
                    resolve();
                })
                .catch(error => {
                    resolve();
                })
            }, error => {
                reject(error);
            })                
    },
    getPaisesSelect: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_SELECT');

            apiAxios.get('paises/list')
                .then(res => {
                    var list = []
                    for(let key in res.data) {
                        const pais = res.data[key]
                        list.push(pais.nombre.trim())
                    } 
                    commit('PAISES_SELECT', res.data)
                    commit('LIST_SELECT', list)
                    resolve();
                })
                .catch(error => {
                    resolve();
                })
            }, error => {
                reject(error);
            })
    },
};

const getters = {
    getField,

    paisesSelect (state) {
        return state.paisesSelect;
    },
    listSelect (state) {
        return state.listSelect;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}